import { render, staticRenderFns } from "./ParcelamentoNaoPrevidenciario.vue?vue&type=template&id=635c8353&"
import script from "./ParcelamentoNaoPrevidenciario.vue?vue&type=script&lang=js&"
export * from "./ParcelamentoNaoPrevidenciario.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports